import type { TabProps } from '@mui/material';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink, useLocation } from 'react-router-dom';

export const CUSTOMER_INVOICE_PAGE_TAB_OPTIONS = Object.freeze({
  DynamicInvoice: 'dynamic',
  PreviewInvoice: 'preview',
});

export type CustomerInvoicePageTabOption =
  (typeof CUSTOMER_INVOICE_PAGE_TAB_OPTIONS)[keyof typeof CUSTOMER_INVOICE_PAGE_TAB_OPTIONS];

export function useCustomerInvoicePageTabs() {
  const location = useLocation();

  const dynamicInvoiceTab = createDynamicInvoiceTab(location);
  const pdfTab = createPdfTab(location);

  const tabs = Object.values({
    [CUSTOMER_INVOICE_PAGE_TAB_OPTIONS.DynamicInvoice]: dynamicInvoiceTab,
    [CUSTOMER_INVOICE_PAGE_TAB_OPTIONS.PreviewInvoice]: pdfTab,
  } satisfies Record<CustomerInvoicePageTabOption, TabProps<typeof NavLink, NavLinkProps>>);

  const currentTab = location.pathname.split('/').pop() as CustomerInvoicePageTabOption;

  return [tabs, currentTab] as const;
}

function createDynamicInvoiceTab(location: ReturnType<typeof useLocation>) {
  return {
    label: 'Dynamic Invoice',
    value: CUSTOMER_INVOICE_PAGE_TAB_OPTIONS.DynamicInvoice,
    component: NavLink,
    to: `${location.pathname}/../dynamic`,
    replace: true,
  };
}

function createPdfTab(location: ReturnType<typeof useLocation>) {
  return {
    label: 'PDF View',
    value: CUSTOMER_INVOICE_PAGE_TAB_OPTIONS.PreviewInvoice,
    component: NavLink,
    to: `${location.pathname}/../preview`,
    replace: true,
  };
}
